import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import React from 'react'
import { CMSState, Link } from '../../../../cms/blocks/types.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { PublicSiteState } from '../../../../public_site.main.mod'
import Plyr from 'react-plyr'
import { DefaultCookiePlaceHolder, link } from '../../../../cms/blocks/utils.gen'
import { CookieSensitiveContentWrapper } from '../../../../cms/blocks/cookiebar.mod'


export type VideoCtaBlockProps = {
  title: string
  intro: string
  video_url: string
  show_primary: boolean
  primary_button?: Link

  show_in_page_navigation: boolean
  navigation_title: string
}

export type VideoCtaBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  text_classname: string
  footer_classname: string
  clickable_primary_classname: string
  clickable_secondary_classname: string
}>

export function VideoCtaBlock<customBlockData, extra_images>(
  props: VideoCtaBlockProps,
  options?: { style?: VideoCtaBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) =>
    mk_widget({
      run: _ => (
        <section
          id={props.navigation_title}
          className="block block--video-cta">
          <div className="block__inner">
            <div className="block__wrap">
              <div className="block__content">
                <header className="block__header">
                  {props.title && <h2 className="block__title title--ms">{props.title}</h2>}
                  {props.intro && <p className="block__intro" dangerouslySetInnerHTML={{ __html: props.intro }} />}
                </header>
                {props.show_primary && props.primary_button && <footer className="block__footer">
                  {link(props.primary_button, { classname: "block__link btn btn--secondary" }, props.primary_button.title)}
                </footer>}
              </div>
              {props.video_url &&
                <figure className="block__visual">
                  <CookieSensitiveContentWrapper
                    options={{ style: {} }}
                    placeholder={DefaultCookiePlaceHolder()}
                  >
                    <Plyr videoId={props.video_url} />
                  </CookieSensitiveContentWrapper>
                </figure>
              }
            </div>
          </div>
        </section>
      )
    })
}



// WEBPACK FOOTER //
// ./Client/components/public_site/blocks/custom_blocks/widgets/videoCta.tsx